export default "__VITE_ASSET__DB7av9$3__"